import { ApiError } from "@/modules/shared/utils/ApiError";
import { isFetchNetworkError } from "@/modules/shared/utils/reactQueryErrorTracking";
import { ShortUrlResolutionStatus } from "@/modules/tracking/consts/ShortUrl";

type ResolutionOutcome = {
  resolution_status: ShortUrlResolutionStatus;
  http_status: number | null;
};

// The backend currently collapses invalid_token / expired / no_session_linked
// / internal-error into a single 404, so 4xx maps to `no_session_linked`.
export function getShortUrlResolutionFromSuccess(
  httpStatus = 200,
): ResolutionOutcome {
  return { resolution_status: "session_linked", http_status: httpStatus };
}

export function getShortUrlResolutionFromError(
  error: unknown,
): ResolutionOutcome {
  if (error instanceof ApiError) {
    if (error.status >= 400 && error.status < 500) {
      return {
        resolution_status: "no_session_linked",
        http_status: error.status,
      };
    }
    return { resolution_status: "error", http_status: error.status };
  }

  if (isFetchNetworkError(error)) {
    return { resolution_status: "error", http_status: null };
  }

  return { resolution_status: "error", http_status: null };
}
